import sendRequest from "@/utils/request"

export const URLS = {
  QueryMeetingRoomBuildings:
    "/api/PcClient/MeetingRoomConfig/QueryMeetingRoomBuildings",
  UpdateMeetingRoomBuilding:
    "/api/PcClient/MeetingRoomConfig/UpdateMeetingRoomBuilding",
  RemoveMeetingRoomBuilding:
    "/api/PcClient/MeetingRoomConfig/RemoveMeetingRoomBuilding",
  BatchUpdateMeetingRoomBuildingCode:
    "/api/PcClient/MeetingRoomConfig/BatchUpdateMeetingRoomBuildingCode",
  QueryMeetingRoomBuildingMapImages:
    "/api/PcClient/MeetingRoomConfig/QueryMeetingRoomBuildingMapImages",
  UpdateMeetingRoomBuildingMapImage:
    "/api/PcClient/MeetingRoomConfig/UpdateMeetingRoomBuildingMapImage",
  CalcApplyMeetingRoomEndTime:
    "/api/PcClient/MeetingRoomMgr/CalcApplyMeetingRoomEndTime",
  QueryMeetingRoomApply:
    "api/PcClient/MeetingRoomApplyMgr/QueryMeetingRoomApply",
  ConfirmMeetingRoomApply:
    "api/PcClient/MeetingRoomMgr/ConfirmMeetingRoomApply",
  QueryMeetingRoomTypes: "api/PcClient/MeetingRoomConfig/QueryMeetingRoomTypes",
  CancelConfirmMeetingRoomApply:
    "api/PcClient/MeetingRoomApplyMgr/CancelConfirmMeetingRoomApply",
  CancelConfirmAndRefuseMeetingRoomApply:
    "api/PcClient/MeetingRoomApplyMgr/CancelConfirmAndRefuseMeetingRoomApply",
  UpdateMeetingRoomApply:
    "/api/PcClient/MeetingRoomApplyMgr/UpdateMeetingRoomApply",
}

const apis = {}
for (const key in URLS) {
  const url = URLS[key]
  apis[key] = (params, option = {}) => {
    return sendRequest(url, params, "post", option)
  }
}
export default apis
